import React from "react"
import { IconArrowUpRight } from "@tabler/icons-react"
import LandingButton from "./LandingButton"

type Props = {
  title: string
  badge?: string
  description?: string
  imageUrl?: string
  ctaLabel?: string
  registerUrl?: string
  showCardText?: boolean
}

const LandingEventCard: React.FC<Props> = ({
  title,
  badge,
  description,
  imageUrl,
  ctaLabel = "Register",
  registerUrl,
  showCardText = true,
}) => {
  const hasText = showCardText && Boolean(badge || title || description)

  return (
    <article className="group flex h-full w-full flex-col overflow-hidden rounded-2xl border border-[#ebebeb]/80 bg-white shadow-[0_12px_40px_-16px_rgba(45,26,69,0.12)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-16px_rgba(45,26,69,0.18)]">
      <div className="relative aspect-video w-full shrink-0 overflow-hidden bg-[#1a1424]">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className="h-full w-full object-contain object-center"
          />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-[#2d1a45] to-[#1a1424]" />
        )}
        {registerUrl && (
          <div className="absolute inset-x-3 bottom-4 z-10 flex justify-center">
            <a
              href={registerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/50 bg-white/10 px-8 py-3.5 font-dm-sans text-base font-semibold tracking-wide text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.55)] shadow-none backdrop-blur-[2px] transition hover:border-white/70 hover:bg-white/20 hover:backdrop-blur-md active:scale-[0.98]"
            >
              {ctaLabel}
              <IconArrowUpRight size={18} stroke={2} />
            </a>
          </div>
        )}
      </div>

      {(hasText || registerUrl) && (
        <div className="flex items-center gap-4 px-5 py-4">
          {hasText && (
            <div className="min-w-0 flex-1">
              {badge && (
                <p className="font-dm-sans text-[10px] font-semibold uppercase tracking-wider text-[#9e7e43]">
                  {badge}
                </p>
              )}
              <h3 className="font-outfit text-lg font-semibold leading-snug tracking-tight text-[#2d1a45] md:text-xl">
                {title}
              </h3>
              {description && (
                <p className="mt-1 line-clamp-2 font-dm-sans text-sm leading-6 text-[#5a5a5a]">
                  {description}
                </p>
              )}
            </div>
          )}
          {registerUrl && (
            <LandingButton href={registerUrl} className={`${hasText ? "" : "ml-auto"} shrink-0`}>
              {ctaLabel}
            </LandingButton>
          )}
        </div>
      )}
    </article>
  )
}

export default LandingEventCard
